export default {
  production: false,
  languages: ['es', 'en'],
  defaultLang: 'en',
  defaultTheme: 'LIGHT',
  //defaultTheme: 'DARK',
  api: {
    url: '',
    name: '',
    secret: '',
  },
  token: {
    refreshOnLoad: true,
    autoRefresh: {
      enabled: true,
      time: 1,
      unit: 'MINUTES',
    },
    reduceTime: {
      enabled: false,
      time: 1,
      unit: 'MINUTES',
    },
  },
  assets: {
    showEuros: true,
    showPercent: true,
  },
  wallets: {
    showEuros: true,
    showPercent: true,
  },
  rateLimiter: {
    enabled: true,
    seconds: 5,
  },
};
